import React from 'react'
import { useHistory } from 'react-router-dom'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Popover from '@material-ui/core/Popover'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import MessageOutlinedIcon from 'components/material-symbol/icons/Message'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  menuItemIcon: {
    color: theme.palette.text.primary,
    minWidth: theme.spacing(5),
  },
}))

const EventsActionsMenu = ({
  event,
  isOpen,
  handleClose,
  anchorEl,
  setIsShareOpen,
}) => {
  const classes = useStyles()
  const history = useHistory()

  const menuItems = [
    {
      Icon: LinkOutlinedIcon,
      text: 'Share',
      onClick: () => setIsShareOpen(true),
    },
    {
      Icon: MessageOutlinedIcon,
      text: 'Message event host',
      onClick: () =>
        history.push(`/things-to-do/events/${event.slug}/messages`),
    },
  ]

  return (
    <Popover
      open={isOpen}
      onClose={handleClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuList autoFocusItem onClick={handleClose}>
        {menuItems.map(({ Icon, text, onClick }) => (
          <MenuItem key={text} onClick={onClick}>
            <ListItemIcon className={classes.menuItemIcon}>
              <Icon fontSize="small" />
            </ListItemIcon>
            {text}
          </MenuItem>
        ))}
      </MenuList>
    </Popover>
  )
}

export default EventsActionsMenu
